import { alpha, styled } from '@mui/material';
import { darkBlue } from 'common/theme/palette';

export const TabsWrapper = styled('div')(({ theme: { palette } }) => ({
  position: 'relative',

  '&:after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    width: '100%',
    height: 2,
    /**
     * The rail the indicator slides along. `alpha(darkBlue, 0.14)` is a navy tint of a light page —
     * on the `Color/Dark/3` panel the media-settings dialog now draws it is indistinguishable from
     * the surface, leaving the indicator floating with nothing to sit on (HNS-367).
     *
     * `palette.divider` is the theme's own answer to "a line on this surface", and the refresh's dark
     * half sets it to `Color/Dark/5`. The light expression is left byte-identical on purpose: making
     * it a ternary in both directions would rotate the Emotion class hash with the flag OFF.
     */
    backgroundColor: palette.mode === 'dark' ? palette.divider : alpha(darkBlue, 0.14),
    borderRadius: 1,
  },
}));
